export const scrollToBottom = () => {
    let scrollContainer = document.getElementById("swiftchat-scroll-div");
    if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
};
